// Calcul automatique de la criticité d'une opération PERMIT&CO.
// Logique métier isolée : aucune dépendance React. Testable et administrable ensuite.

const TRAVAIL_POIDS = {
  espace_confine: 4, point_chaud: 3, electrique: 3, levage: 3, hauteur: 3,
  toiture: 3, chimique: 3, fouille: 2, maintenance_machine: 2, engins: 2,
  isole: 2, poussiereux: 1, bruyant: 1,
};

const ATTR_POIDS = {
  atex: 4, produits_inflammables: 3, espace_confine: 3, sans_alerte: 2,
  circulation_engins: 2, circulation_pietonne: 2, zone_alimentaire: 2,
  communication_critique: 1, hauteur: 1, consignable: 0,
};

const TRAVAIL_LABEL = {
  point_chaud: "Travail par point chaud", hauteur: "Travail en hauteur",
  espace_confine: "Espace confiné", electrique: "Intervention électrique",
  levage: "Levage / manutention", fouille: "Fouille / excavation",
  chimique: "Produits chimiques", toiture: "Intervention en toiture",
  poussiereux: "Travaux poussiéreux", engins: "Circulation d'engins",
  bruyant: "Travaux bruyants", isole: "Travail isolé", maintenance_machine: "Maintenance machine",
};
const ATTR_LABEL = {
  produits_inflammables: "Zone à produits inflammables", atex: "Zone ATEX",
  espace_confine: "Zone espace confiné", circulation_pietonne: "Circulation piétonne",
  circulation_engins: "Circulation d'engins", zone_alimentaire: "Zone alimentaire/sensible",
  communication_critique: "Communication critique", sans_alerte: "Zone sans couverture d'alerte",
  hauteur: "Poste en hauteur", consignable: "Installation consignable",
};

// zones: [{attributs:[...]}] correspondant aux zones sélectionnées
export function computeCriticite(form, zonesSelectionnees = []) {
  const facteurs = [];
  let score = 0;
  const add = (label, poids) => { if (poids > 0) { score += poids; facteurs.push({ label, poids }); } };

  (form.natureTravaux || []).forEach((t) => add(TRAVAIL_LABEL[t] || t, TRAVAIL_POIDS[t] || 1));

  const attrsVus = new Set();
  zonesSelectionnees.forEach((z) => (z.attributs || []).forEach((a) => {
    if (!attrsVus.has(a)) { attrsVus.add(a); add(ATTR_LABEL[a] || a, ATTR_POIDS[a] ?? 1); }
  }));

  if (form.siteOccupe) add("Site occupé pendant les travaux", 2);
  if (form.presencePublicOuCollaborateurs) add("Présence de public / collaborateurs", 2);
  if (form.sousTraitance) add("Recours à la sous-traitance", 1);
  if ((form.zones || []).length > 1) add("Coactivité sur plusieurs zones", 1);
  if (form.horaires === "nuit") add("Travaux de nuit", 1);
  if (form.recurrence === "ponctuels") add("Intervention ponctuelle (moindre routine)", 1);

  let niveau = "faible";
  if (score > 10) niveau = "critique";
  else if (score > 6) niveau = "elevee";
  else if (score > 3) niveau = "moderee";

  facteurs.sort((a, b) => b.poids - a.poids);
  const top = facteurs.slice(0, 3).map((f) => f.label.toLowerCase());
  const justification = facteurs.length
    ? `Criticité ${labelNiveau(niveau).toLowerCase()} (score ${score}) principalement liée à : ${top.join(", ")}.`
    : "Aucun facteur de risque significatif saisi pour le moment.";

  return { niveau, score, facteurs, justification };
}

export function labelNiveau(n) {
  return { faible: "Faible", moderee: "Modérée", elevee: "Élevée", critique: "Critique" }[n] || n;
}
